export default {
  VIDEOS: "Videos",
  VIDEO: "Video",
};
